var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{staticClass:"mb-4",attrs:{"header":_vm.$t('productsCurrentlyNotAvailable'),"fields":_vm.fields,"items":_vm.items,"loading":_vm.loading,"error":_vm.request.getError(),"show-export-button":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }